// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".together{position:relative}.attributes{position:absolute;bottom:5px;right:5px}.name-attributes{position:absolute;bottom:0px;right:0px}.editor{background-color:#fff}", ""]);
// Exports
module.exports = exports;
